import ThemeInterface, { Color } from './ThemeInterface'

const themeName = 'dark'

const colors: Color = {
    // Standard colors
    onyx: '#FFFFFF',
    'onyx-2': '#404040',
    'onyx-3': '#808080',
    'onyx-4': '#A8A8A8',
    'onyx-5': '#E5E5E5',

    pearl: '#000000',
    'pearl-2': '#282828',
    'pearl-3': '#404040',
    'pearl-4': '#E5E5E5',

    basra: '#282828',

    keshi: '#FFFFFF',
    'keshi-2': '#F6A800',
    'keshi-3': '#A8A8A8',
    'keshi-4': '#E5E5E5',

    moon: '#000000',
    'moon-2': '#808080',
    'moon-3': '#A8A8A8',
    'moon-4': '#404040',
    'moon-5': '#808080',

    tahitian: '#000000',
    'tahitian-2': '#282828',
    'tahitian-3': '#404040',
    'tahitian-4': '#808080',
    'tahitian-5': '#E5E5E5',

    // Special Colors
    'onyx-opacity-12': 'rgba(0, 0, 0, 0.12)',
    'onyx-opacity-50': 'rgba(0, 0, 0, 0.5)',
    'onyx-opacity-70': 'rgba(64, 64, 64, 0.7)',
    'pearl-opacity-35': 'rgba(255, 255, 255, 0.35)',
    'pearl-opacity-70': 'rgba(44, 44, 44, 0.7)',
    amber: '#F6A800',

    // Fixed Colors
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    GRAY16: '#282828',
    GRAY25: '#404040',
    GRAY50: '#808080',
    GRAY66: '#A8A8A8',
    GRAY90: '#E5E5E5',
    GRAY96: '#F5F5F5',

    ORANGE: '#F6A800',
    GREEN: '#0F9D58',
    LIGHTGREEN: '#00D279',
    BLUE: '#003F94',
    LIGHTBLUE: '#4285F4',
    YELLOW: '#FFEA00',
    RED: '#FF3A3A',

    TRANSPARENT: '#00000000',
}

const fontFamily = 'Sport1-Regular'

const fontFamilyBold = 'Sport1-Bold'

const fontSizes = {
    FS10: '10px',
    FS11: '11px',
    FS12: '12px',
    FS14: '14px',
    FS15: '15px',
    FS16: '16px',
    FS18: '18px',
    FS20: '20px',
    FS22: '22px',
    FS28: '28px',
    FS30: '30px',
    FS36: '36px',
    FS48: '48px',
}

const lineHeights = {
    LH14: '14px',
    LH16: '16px',
    LH20: '20px',
    LH22: '22px',
    LH24: '24px',
    LH30: '30px',
    LH34: '34px',
    LH36: '36px',
    LH58: '58px',
}

// space is used for margin and padding scales
// it's recommended to use powers of two to ensure alignment
// when used in nested elements
// numbers are converted to px
const space = [0, 2, 4, 8, 12, 16, 24, 32, 40]

// radii is used for border-radius scales
// numbers are converted to radii
const radii = [0, 2, 4, 6, 8, 10, 11, 12, 16]

const darkTheme: ThemeInterface = {
    themeName,
    colors,
    fontFamily,
    fontFamilyBold,
    fontSizes,
    lineHeights,
    space,
    radii,
}

export default darkTheme
